import React, {useState} from 'react';
import styles from "./ShopikoTemplatesModal.scss";
import Modal from "@components/base/Modal/Modal";
import ShopikoTemplatesModalData from "./data/ShopikoTemplatesModalData";
import language from "@lang/language";

// Modal with content
const ShopikoTemplatesModal = ({color = ''}) => {

	const [isModalOpen, setIsModalOpen] = useState(true);

	if (!isModalOpen) {
		return null;
	}

	return (
	  <Modal onClose={() => setIsModalOpen(false)}>
		  <Content data={ShopikoTemplatesModalData} color={color}/>
	  </Modal>
	)
}

// Content of the modal
const Content = ({data, color = ''}) => {
	const {
		modalTitle,
		templateCategories
	} = data;

	if (!data || !templateCategories || templateCategories.length === 0) {
		return;
	}

	return (
	  <div className={styles.containerScroll}>
		  <div className={styles.container}>
			  {/*Modal title*/}
			  <h3>{modalTitle}</h3>

			  <div className={styles.categoriesHolder}>
				  {/*Categories*/}
				  {templateCategories.map((item, key) => (
					<div className={styles.categories} key={key}>
						<h4>{item.name}</h4>

						{/*Templates*/}
						<div className={styles.templatesHolder}>
							{item.templates.length > 0 && item.templates.map((template, templateKey) => (
							  <div className={styles.row} key={templateKey}>
								  <a href={template.href} target={'_blank'} title={template.name}>
									  <img
										src={template.img}
										alt={template.name}
										title={template.name + language.shBGTitle}
										width={384}
										height={578}
									  />
								  </a>

								  <div className={styles.nameHolder}>
									  {/*Template name*/}
									  <div>{template.name}</div>

									  {/*Template tags*/}
									  {template.tags && template.tags.length > 0 &&
										<>
											{template.tags.map((tag, tagKey) => (
											  <div
												className={`${styles.tag} ${tag.color ? styles[tag.color] : ''}`}
												key={tagKey}>
												  {tag.name}
											  </div>
											))}
										</>
									  }
								  </div>
							  </div>
							))}
						</div>
					</div>
				  ))}
			  </div>
		  </div>
	  </div>
	)
}

export default ShopikoTemplatesModal;
